import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import { withStyles } from '@material-ui/core/styles'
import { resetPatientDevice } from '../api.js'

const styles = theme => ({
  root: {
    textTransform: 'uppercase',
    padding: 20,
    color: 'silver'
  },
  logoutButton: {
    textDecoration: 'underline',
    display: 'inline',
    cursor: 'pointer',
    color: 'silver'
  }
})

class DeviceResetModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isModalOpen: false
    }
  }

  resetDevice = () => {
    resetPatientDevice(this.props.patient.deviceId).then(response => {
      this.props.history.push(`/patients`)
    })
  }

  toggleModal = (e) => this.setState({ isModalOpen: !this.state.isModalOpen })

  render () {
    const { patient } = this.props
    const { username } = this.state

    if (!patient) return <div/>
    return (
      <div>
        <Button fullWidth color="primary" onClick={this.toggleModal} disabled={!patient.deviceId}>
          {patient.deviceId ? `RESET DEVICE #${patient.deviceId}` : 'No Device Associated'}
        </Button>
        <Dialog open={this.state.isModalOpen} onClose={() => this.setState({ isModalOpen: false })}>
          <DialogTitle>Are you sure you want to reset this device?</DialogTitle>
          <DialogActions>
            <Button fullWidth variant="contained" color="primary" onClick={this.resetDevice}>
              Reset
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withStyles(styles)(DeviceResetModal)



// WEBPACK FOOTER //
// ./src/components/DeviceResetModal.js